const GET_CONFIG_KEYS = 'dofe-bo/configuration/GET_CONFIG_KEYS'
const GET_CONFIG_KEYS_SUCCESS = 'dofe-bo/configuration/GET_CONFIG_KEYS_SUCCESS'
const GET_CONFIG_KEYS_FAIL = 'dofe-bo/configuration/GET_CONFIG_KEYS_FAIL'
const GET_CONFIG_KEY_VALUE = 'dofe-bo/configuration/GET_CONFIG_KEY_VALUE'
const GET_CONFIG_KEY_VALUE_SUCCESS =
  'dofe-bo/configuration/GET_CONFIG_KEY_VALUE_SUCCESS'
const GET_CONFIG_KEY_VALUE_FAIL =
  'dofe-bo/configuration/GET_CONFIG_KEY_VALUE_FAIL'

const GET_CONFIG_VALUES = 'dofe-bo/configuration/GET_CONFIG_VALUES'
const GET_CONFIG_VALUES_SUCCESS =
  'dofe-bo/configuration/GET_CONFIG_VALUES_SUCCESS'
const GET_CONFIG_VALUES_FAIL = 'dofe-bo/configuration/GET_CONFIG_VALUES_FAIL'

const UPDATE_CONFIG_VALUES = 'dofe-bo/configuration/UPDATE_CONFIG_VALUES'
const UPDATE_CONFIG_VALUES_SUCCESS =
  'dofe-bo/configuration/UPDATE_CONFIG_VALUES_SUCCESS'
const UPDATE_CONFIG_VALUES_FAIL =
  'dofe-bo/configuration/UPDATE_CONFIG_VALUES_FAIL'

const UPDATE_CONFIG_VALUES_BULK = 'dofe-bo/configuration/UPDATE_CONFIG_VALUES_BULK'
const UPDATE_CONFIG_VALUES_BULK_SUCCESS =
    'dofe-bo/configuration/UPDATE_CONFIG_VALUES_BULK_SUCCESS'
const UPDATE_CONFIG_VALUES_BULK_FAIL =
    'dofe-bo/configuration/UPDATE_CONFIG_VALUES_BULK_FAIL'

const initialState = {
  keys: [],
  values: {},
  allValues: [],
  valuesByOrganizationId: {},
  bulk: {}
}

export default function reducer(state = initialState, action = {}) {
  const isArray = action.result && action.result.length > 0

  switch (action.type) {
    case GET_CONFIG_KEYS:
      return {
        ...state,
        loading: true
      }
    case GET_CONFIG_KEYS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        keys: action.result
      }
    case GET_CONFIG_KEYS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_CONFIG_VALUES:
      return {
        ...state,
        loading: true
      }
    case GET_CONFIG_VALUES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        allValues: action.result
      }
    case GET_CONFIG_VALUES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_CONFIG_KEY_VALUE:
      return {
        ...state,
        loading: true
      }
    case GET_CONFIG_KEY_VALUE_SUCCESS:
      // temporary solution - display list on configuration values in UI
      if (!action.result.configurationKey && !isArray) {
        return {
          ...state,
          loading: false
        }
      }
      // calling multiple configs in 1 API call
      if (isArray) {
        let configStructure = {}

        let organisationConfigStructure = {}

        action.result.forEach(item => {
          configStructure = Object.assign({}, configStructure, {
            [item.configurationKey.keyName.value]: {
              ...item
            }
          })

          organisationConfigStructure = {
            ...Object.assign(
              {},
              state.valuesByOrganizationId &&
              state.valuesByOrganizationId[action.organizationId],
              organisationConfigStructure,
              {
                [item.configurationKey.keyName.value]: {
                  ...item
                }
              }
            )
          }
        })

        return {
          ...state,
          loading: false,
          loaded: true,
          values: Object.assign({}, state.values, configStructure),
          valuesByOrganizationId: {
            ...state.valuesByOrganizationId,
            [action.organizationId]: organisationConfigStructure
          }
        }
      }

      // Return for single config
      return {
        ...state,
        loading: false,
        loaded: true,
        values: Object.assign({}, state.values, {
          [action.result.configurationKey.keyName.value]: {
            ...action.result
          }
        }),
        valuesByOrganizationId: {
          ...state.valuesByOrganizationId,
          [action.organizationId]: Object.assign(
            {},
            state.valuesByOrganizationId &&
            state.valuesByOrganizationId[action.organizationId],
            {
              [action.result.configurationKey.keyName.value]: {
                ...action.result
              }
            }
          )
        }
      }
    case GET_CONFIG_KEY_VALUE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case UPDATE_CONFIG_VALUES_BULK:
      return {
        ...state,
        bulk: {
          ...state.bulk,
          loading: true,
          loaded: false
        }
      }
    case UPDATE_CONFIG_VALUES_BULK_SUCCESS:
      return {
        ...state,
        bulk: {
          ...state.bulk,
          loading: false,
          loaded: true,
          detail: action.result
        }
      }
    case UPDATE_CONFIG_VALUES_BULK_FAIL:
      return {
        ...state,
        bulk: {
          ...state.bulk,
          loading: false,
          error: action.error
        }
      }
    default:
      return state
  }
}

export function getConfigurationKeys() {
  return {
    types: [GET_CONFIG_KEYS, GET_CONFIG_KEYS_SUCCESS, GET_CONFIG_KEYS_FAIL],
    promise: client => client.get('api/configuration-keys')
  }
}

export function getConfigurationKeyValues(values, { organizationId } = {}) {
  return {
    types: [
      GET_CONFIG_KEY_VALUE,
      GET_CONFIG_KEY_VALUE_SUCCESS,
      GET_CONFIG_KEY_VALUE_FAIL
    ],
    promise: client =>
      client.get(
        `api/configuration-values/organization/${organizationId}?keys=${values.join(',')}`
      ),
    organizationId
  }
}

export function getConfigurationKeyValue(name, { organizationId } = {}) {
  const routeParams = organizationId ? `?organizationId=${organizationId}` : ''

  return {
    types: [
      GET_CONFIG_KEY_VALUE,
      GET_CONFIG_KEY_VALUE_SUCCESS,
      GET_CONFIG_KEY_VALUE_FAIL
    ],
    promise: client =>
      client.get(`api/configuration-keys/${name}/value${routeParams}`),
    organizationId
  }
}

export function getConfigurationAllValues(organizationId) {
  return {
    types: [
      GET_CONFIG_VALUES,
      GET_CONFIG_VALUES_SUCCESS,
      GET_CONFIG_VALUES_FAIL
    ],
    promise: client =>
      client.get(`api/configuration-values/organization/${organizationId}`)
  }
}

export function updateConfigurationKey(key, organizationId, data) {
  return {
    types: [
      UPDATE_CONFIG_VALUES,
      UPDATE_CONFIG_VALUES_SUCCESS,
      UPDATE_CONFIG_VALUES_FAIL
    ],
    promise: client =>
      client.put(
        `api/configuration-keys/${key}/organizations/${organizationId}/configuration-values`,
        {
          data
        }
      )
  }
}

export function updateConfigurationKeyBulk(data) {
  return {
    types: [
      UPDATE_CONFIG_VALUES_BULK,
      UPDATE_CONFIG_VALUES_BULK_SUCCESS,
      UPDATE_CONFIG_VALUES_BULK_FAIL
    ],
    promise: client =>
        client.post('api/configuration-keys/configuration-values/bulk', { data })
  }
}

